import type { HandoverOverview } from '@testflow/shared';
import { groupOf } from './playlist-groups.js';
import type { PlaylistEntry } from './runs-api.js';

// #195: reine Regeln für die Auswahl „Abgeben" in „Meine Tests". Der Server entscheidet, was
// weitergebbar ist (`overview.mine`); hier wird nur gerechnet, was die Oberfläche daraus zeigt.

/**
 * Trägt diese Karte ein Auswahlkästchen und zählt sie in „N ausgewählt"? Eigene Karte (keine
 * Vertretung, W10) und nicht erledigt — Erledigtes „erscheint in keiner Liste und keiner Zählung"
 * (W3). Dass der Testfall selbst weitergebbar ist, sagt `overview.mine`; ein Testfall in zwei
 * Ketten kann eine erledigte und eine offene Karte haben, und nur die offene wandert mit.
 */
export function isHandoverCard(entry: PlaylistEntry): boolean {
  return entry.substituted_for === null && groupOf(entry) !== 'done';
}

/**
 * Kollegen, die für ALLE markierten Testfälle zulässig sind: die Schnittmenge der `targets`, in
 * der Reihenfolge der ersten markierten Zeile. Ohne Markierung gibt es kein Ziel.
 */
export function commonTargets(
  selected: ReadonlySet<string>,
  mine: HandoverOverview['mine'],
): string[] {
  let common: string[] | null = null;
  for (const row of mine) {
    if (!selected.has(row.test_case_id)) continue;
    common =
      common === null ? [...row.targets] : common.filter((user) => row.targets.includes(user));
  }
  return common ?? [];
}

/**
 * „N ausgewählt" zählt Einträge (Testfall × Kette), nicht Testfälle (`CONTEXT.md`
 * „Playlist-Eintrag"): ein markierter Testfall in zwei Ketten sind zwei Karten.
 */
export function selectedEntryCount(
  selected: ReadonlySet<string>,
  entries: PlaylistEntry[],
): number {
  return entries.filter((e) => selected.has(e.test_case_id) && isHandoverCard(e)).length;
}
